import { Image } from 'antd';
import ActionHeader from '../../../components/actionHeader';
import Page from '../../../components/page';
import { useTranslation } from 'react-i18next';

const PeopleInsight = () => {
  const { t } = useTranslation();
  return (
    <Page header={<ActionHeader title={t('people_reserve_coming_soon')} />}>
      <div style={{ padding: 24 }}>
        <Image
          src="/people_insight.png"
          preview={false}
          style={{ width: '100%' }}
        ></Image>
      </div>
    </Page>
  );
};

export default PeopleInsight;
